<template>
  <tr class="even:bg-white odd:bg-gray-50">
    <td class="px-4 py-4 text-sm text-gray-500 align-top">
      <p class="break-words">{{ number }}</p>
      <ul>
        <li v-for="contact in trackingLog.contacts" :key="contact.id">
          <a
            role="button"
            class="text-gray-600 text-xs break-words underline"
            @click.prevent="showContact(contact.id)"
          >
            {{ contact.full_name }}
          </a>
        </li>
      </ul>
    </td>
    <td class="px-4 py-4 text-sm text-gray-500">
      {{ status }}
    </td>
    <td class="px-4 py-4 text-sm text-gray-500">
      {{ deliveryStatus }}
    </td>
  </tr>
</template>

<script>
import { capitalize } from 'lodash-es';

export default {
  props: {
    trackingLog: {
      type: Object,
      required: true,
    },
  },
  computed: {
    recipientName() {
      return this.trackingLog?.contact?.full_name || 'N/A';
    },
    status() {
      const { status = '' } = this.trackingLog;

      return status ? capitalize(status) : 'N/A';
    },
    number() {
      const { msisdn = '' } = this.trackingLog?.delivery_receipt?.[0] || {};

      return msisdn || 'N/A';
    },
    deliveryStatus() {
      const statuses = (this.trackingLog?.delivery_receipt || [])
        .map((receipt) => capitalize(receipt.status))
        .join(', ');

      return statuses || 'N/A';
    },
  },
};
</script>
